import intl from '../../../shared/intl';

const defaultInitialState = {
	isShow: false,
	formInitialValues: {
		closeMessage: 'The issue is resolved'
	}
};

const createCloseForm = ({
	namespace,
	stateNodeName
}) => {
	const TOGGLE_CLOSE_FORM = `${namespace}/${stateNodeName}-toggle-close-form`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		toggleCloseForm: () => ({
			type: TOGGLE_CLOSE_FORM
		})
	};

	// reducers
	const reducers = {
		[TOGGLE_CLOSE_FORM]: state => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				isShow: !state[stateNodeName].isShow
			}
		})
	};

	// selectors
	const selectors = {
		getInitialValues: state => {
			const translatorKey = state[namespace][stateNodeName].formInitialValues.closeMessage;
			return {
				closeMessage: translatorKey
			};
		},
		getShouldShowCloseFormStatus: state => state[namespace][stateNodeName].isShow,
		getCloseFormValidate: state => values => {
			const errors = [];
			const translator = intl(state);

			if (!values.closeMessage) {
				errors.closeMessage = translator('Message is required');
			}

			return errors;
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createCloseForm;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/close-form/index.js